module.exports = __webpack_public_path__ + "static/media/Ostern.bc7fd55e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Ostern.jpg
// module id = 330
// module chunks = 0